import { ukLocale } from './MappedLocales';

export const formatNumber = (
  value: number,
  minimumFractionDigits = 0,
  maximumFractionDigits = 0,
  config: Intl.NumberFormatOptions = {},
) => {
  const options: Intl.NumberFormatOptions = {
    minimumFractionDigits,
    maximumFractionDigits,
    ...config,
  };

  return new Intl.NumberFormat(ukLocale, options).format(value);
};
